import { type ReactNode } from 'react';

type CalloutSize = 'sm' | 'md';

const SIZE_CLASSES: Record<CalloutSize, string> = {
  sm: 'items-center gap-2 rounded-md px-3 py-2',
  md: 'items-start gap-2 rounded-xl px-4 py-3',
};

const TEXT_CLASSES: Record<CalloutSize, string> = {
  sm: 'text-sm font-medium',
  md: 'text-xs',
};

interface Props {
  icon: ReactNode;
  children: ReactNode;
  size?: CalloutSize;
}

export default function Callout({ icon, children, size = 'md' }: Props) {
  return (
    <div className={`flex border border-accent-200 bg-accent-50 text-accent-800 ${SIZE_CLASSES[size]}`}>
      {icon}
      <span className={TEXT_CLASSES[size]}>{children}</span>
    </div>
  );
}
